import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-tiny'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type SlugParam = string | string[] | undefined;

export function getSlugFromParam(param: SlugParam): string | undefined {
  if (typeof param === 'string') return param;

  return param?.[0];
}
